export default __webpack_public_path__ + "static/media/Hair_8_M_C2.90cd8224.svg";